import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Company } from '../model/company';

const baseQuery = fetchBaseQuery({
  baseUrl: "https://lk.seafoodexporussia.com/lists/y2026"
})

const AppAPI = createApi({
  reducerPath: "AppAPI",
  baseQuery,
  endpoints: (build) => ({
    getTableData: build.query<any, { filter?: any, page?: number, lang?:string }>({
      query: ({ filter, page,  lang}) => ({
        url: "company-rest/data",
        method: "POST",
        body: filter,
        params: { page, lang }
      })
    }),
    getCategories: build.query({
      query: () => "filter/category-list"
    }),
    getActivities: build.query({
      query: () => "filter/activity-list"
    }),
    getCountries: build.query({
      query: (lang:string) => ({
        url: "filter/country-list",
        params: { lang }
      })
    }),
    getCompanyInfo: build.query<Company, string | number>({
      query: (id: string | number) => ({
        url: "company-rest/view",
        params: { id }
      })
    })
  })
})

export default AppAPI
